// Fired on window by the Structure/Piping modules after a successful save,
// with `detail.projectId`, so an open EMS tree (useEmsProjectsTreeData) can
// refresh that WBS's Estimation revisions. Kept in its own module so the
// modules don't pull in the tree's data hook and its API imports.
export const PROJECT_SAVED_EVENT = "ems-tree:project-saved";

export const notifyProjectSaved = (projectId) => {
  if (projectId == null || projectId === "") return;
  window.dispatchEvent(
    new CustomEvent(PROJECT_SAVED_EVENT, { detail: { projectId } }),
  );
};

// The mirror of the above, fired by the tree itself (updateWbs in
// useEmsProjectsTreeData) after a WBS is renamed or its description rewritten,
// with `detail.projectId`. Every module page keeps its own copy of the WBS
// record - the name and description shown in its header, and the names half of
// every Rev UID is built from - fetched when that WBS was opened; without this
// they keep showing the old one until the page is reloaded.
export const WBS_UPDATED_EVENT = "ems-tree:wbs-updated";

// `changes` is what was edited ({ name, description }), so a listener can
// update its own copy in place instead of re-fetching the record - that is
// what makes an edit show up instantly rather than a round trip later.
export const notifyWbsUpdated = (projectId, changes = {}) => {
  if (projectId == null || projectId === "") return;
  window.dispatchEvent(
    new CustomEvent(WBS_UPDATED_EVENT, { detail: { projectId, changes } }),
  );
};

// The same, one level up: a project (plant) renamed or redescribed. Its
// name is the other half of every Rev UID, and the "PROJECT# UID" of every
// module header.
export const PLANT_UPDATED_EVENT = "ems-tree:plant-updated";

export const notifyPlantUpdated = (plantId, changes = {}) => {
  if (plantId == null || plantId === "") return;
  window.dispatchEvent(
    new CustomEvent(PLANT_UPDATED_EVENT, { detail: { plantId, changes } }),
  );
};
